import React from 'react';
import { Toaster } from 'react-hot-toast';

import './style.css';

export default function CustomToaster() {
  return (
    <Toaster
      toastOptions={{
        className: 'custom-toast container',
        style: {
          color: '#ffffff',
          background: '#5b8ad8',
          borderRadius: 3,
          padding: '14px 10px',
          fontSize: 16,
          maxWidth: 'inherit',
        },
        icon: null,
        error: {
          style: {
            background: '#d04237',
          },
        },
      }}
    />
  );
}
